import HttpService from "../base/HttpService";
export default class FinanceService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;
  getDataProfit(param) {
    const api = this.api + "finance/profit/summary";

    return this.get(param, api);
  }
  getDataProfitChart(param, id) {
    const api = this.api + `finance/profit/summary/${id}`;

    return this.get(param, api);
  }
  getDataCash(param) {
    const api = this.api + "finance/cash/summary";

    return this.get(param, api);
  }
  getDataCashChart(param) {
    const api = this.api + "finance/cash/summary/balance";

    return this.get(param, api);
  }
  getAssetManagement(param) {
    const api = this.api + "finance/asset/summary";

    return this.get(param, api);
  }
  getComboInstance(param) {
    const api = this.api + "ref/instance";

    return this.get(param, api);
  }
  getCashDetail(param) {
    const api = this.api + "finance/cash/detail";

    return this.get(param, api);
  }
  getCashDetailChart(param) {
    const api = this.api + "finance/cash/chart";

    return this.get(param, api);
  }
  getProfitDetail(param) {
    const api = this.api + "finance/profit/detail";

    return this.get(param, api);
  }
  getAssetDetailRatio(param) {
    const api = this.api + "finance/asset/detail/ratio";

    return this.get(param, api);
  }
  getAssetDetailRatioChart(param) {
    const api = this.api + `finance/asset/detail/ratio/${param}`;

    return this.get("", api);
  }
  getAssetDetailManagementTop(param) {
    const api = this.api + "finance/asset/detail/management/top";

    return this.get(param, api);
  }
  getAssetDetailManagementTopChart(param) {
    const api = this.api + `finance/asset/detail/management/top/${param}`;

    return this.get("", api);
  }
  getAssetDetailManagementOther(param) {
    const api = this.api + "finance/asset/detail/management/others";

    return this.get(param, api);
  }
}
